import { Modal, Space, Button } from "antd";

const CommonModal = (props) => {
    const {
        okButtonProps,
        cancelButtonProps,
        doOnClose,
        header,
        modalCloseIcon,
        body,
        contentSpaceSize,
        mask,
        modalCustomClassName,
    } = props;
    const headerClasses = {
        large: "fs-4 fw-medium",
        small: "fs-6 fw-light",
    };

    return (
        <Modal
            {...props}
            className={`${modalCustomClassName ? modalCustomClassName + " " : "hs-min-w-350 "}` + props?.className}
            onCancel={doOnClose && doOnClose}
            centered
            closeIcon={null}
            mask={mask ?? false}
            maskClosable={false}
            footer={null}
        >
            <div className="d-flex justify-content-between align-items-start">
                <span className={headerClasses[contentSpaceSize]}>{header}</span>
                {modalCloseIcon && (
                    <div
                        onClick={doOnClose && doOnClose}
                        className={"actionIconsSprite mediumSprite closeIconBig ms-2"}
                    />
                )}
            </div>
            <Space size={contentSpaceSize ?? "large"} className="w-100 h-100 modalContent" direction="vertical">
                {body}
                {cancelButtonProps || okButtonProps ? (
                    <div className="d-flex justify-content-end pb-3">
                        <div className="d-flex align-items-center gap-4">
                            {cancelButtonProps && (
                                <Button
                                    danger={cancelButtonProps?.danger ?? true}
                                    {...cancelButtonProps}
                                    className={`hs-border-10 big-button hs-fs-16 px-3 ${cancelButtonProps?.className}`}
                                >
                                    <span className="px-3">{cancelButtonProps?.buttonText}</span>
                                </Button>
                            )}
                            {okButtonProps && (
                                <Button
                                    {...okButtonProps}
                                    className={`hs-bg-violet hs-border-10 big-button text-white hs-fs-16 px-3 ${okButtonProps?.className}`}
                                >
                                    <span className="px-3">{okButtonProps?.buttonText}</span>
                                </Button>
                            )}
                        </div>
                    </div>
                ) : null}
            </Space>
        </Modal>
    );
};

export default CommonModal;
